import { useUser } from '@/contexts/UserContext';

export function usePatientNameFormat() {
  const { user } = useUser();
  return user?.organization?.settings?.calendar_display?.patient_name_format || 'first_last';
}
